import VeteranTypeService from "../../../Services/VeteranType.service";
import { makeSearch, makeMultiSearch } from "../../UI/Search/Search";
const makeSearchArgs = {
    loadOptions: (search, options) => VeteranTypeService.getVeteranTypes(Object.assign(Object.assign({}, options), { query: search })).then(({ data }) => data),
    label: "name",
    value: "id",
};
export const VeteranSearch = makeSearch(makeSearchArgs);
export const VeteranMultiSearch = makeMultiSearch(Object.assign({}, makeSearchArgs));
